import { Package } from 'src/app/shared/models/package.model';
import { Schedule } from '@rschedule/core/generators';
import '@rschedule/moment-date-adapter/setup';
import { EventInput } from '@fullcalendar/core';
import { PackageScheduleService } from '../package-schedule.service';
import { BehaviorSubject } from 'rxjs';
import _ from 'lodash';
import moment from 'moment';


export class PackageSchedule {

  availabilityInstances: BehaviorSubject<Array<AvailabilityInstance>> = new BehaviorSubject([]);
  formattedAvailability: BehaviorSubject<Array<EventInput>> = new BehaviorSubject([]);


  constructor(
    public travelPackage: Package,
    private packageService: PackageScheduleService
  ) {
    this.init();
  }


  blockDay(dateLike, extras?) {
    this.packageService.addAvailabilityInstance(
      this.travelPackage.id,
      false,
      dateLike,
      extras
    ).then(() => {
      this.fetchAvailability();
    }).catch(err => {
      console.log(err);
    });
  }

  async unblockDay(dateLike) {
    const blockedDays = this.availabilityInstances.value.filter(av => {
      return moment(av.startTime).isSame(dateLike, 'day') && av.type === 'BLOCKED';
    });

    for (const blockedDay of blockedDays) {
      await this.deleteAvailability(blockedDay.id);
    }

    this.fetchAvailability();
  }


  private async init() {
    this.fetchAvailability();
    this.availabilityInstances.subscribe(() => {
      this.formatAvailability();
    });
  }


  private async fetchAvailability() {
    if (!this.travelPackage && !this.travelPackage.id) {
      return;
    }
    try {
      const response = await this.packageService.getPackageAvailability(this.travelPackage.id);
      this.availabilityInstances.next(response.data.availability);
    } catch (err) {
      console.log(err);
    }
  }

  private formatAvailability(): Array<EventInput> {
    if (this.availabilityInstances) {
      const formatted = this.availabilityInstances.value.map(av => {
        return {
          id: this.travelPackage.id,
          title: this.travelPackage.name,
          start: av.startTime,
          end: av.endTime,
          rendering: av.type === 'BLOCKED' ? 'background' : undefined,
          backgroundColor: av.type === 'BLOCKED' ? 'red' : undefined,
          allDay: av.type === 'BLOCKED'
        } as EventInput;
      });
      this.formattedAvailability.next(formatted);
    } else {
      return [];
    }
  }

  private async deleteAvailability(id) {
    try {
      await this.packageService.deleteAvailabilityInstance(id);
    } catch(err) {
      console.log(err);
    }
  }

}


interface AvailabilityInstance {
  startTime: string;
  endTime: string;
  type: 'AVAILABLE' | 'BLOCKED';
  id?: number;
}
